import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";

export const USER_QUERY_LIMIT = 100;

/** Creators for Gallery, Home stats, search catalog, etc. */
export async function fetchCreators(max = USER_QUERY_LIMIT) {
  const snap = await getDocs(
    query(
      collection(db, "users"),
      where("isCreator", "==", true),
      limit(max)
    )
  );
  return snap.docs.map((d) => ({ id: d.id, uid: d.id, ...d.data() }));
}

/** Fans for admin roster, fan-specific lists, etc. */
export async function fetchFans(max = USER_QUERY_LIMIT) {
  const snap = await getDocs(
    query(
      collection(db, "users"),
      where("isCreator", "==", false),
      limit(max)
    )
  );
  return snap.docs.map((d) => ({ id: d.id, uid: d.id, ...d.data() }));
}

/** Load user documents by id (batched getDoc). */
export async function fetchUsersByIds(userIds) {
  const ids = [...new Set(userIds.filter(Boolean))];
  if (!ids.length) return [];

  const results = await Promise.all(
    ids.map(async (id) => {
      const snap = await getDoc(doc(db, "users", id));
      return snap.exists() ? { id: snap.id, uid: snap.id, ...snap.data() } : null;
    })
  );
  return results.filter(Boolean);
}
